import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppBootingConfig = {
    baseHtmlClass: 'online_app__booting',
    selector: '.online_app__booting',
    loadingIndicatorSelector: '.app_boot__indicator',
    dismisserSelector: '.app_boot__dismisser'
}

export class OnlineAppBooting extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppBootingConfig);

        this.dismisserElement = this.element.querySelector(OnlineAppBootingConfig.dismisserSelector);
        if (this.dismisserElement) {
            this.dismisserElement.innerHTML = `${this.onlineApp.clickActionName} to continue`;
        }

        if (this.element) {
            this.element.addEventListener('click', (e) => {
                e.preventDefault();
                if (!this.readState('booting')) {
                    this.deconstruct();
                }
            });
        }
    }

    deconstruct() {
        this.addHtmlClassState('closed');
        this.onlineApp.env.setTimeout(() => {
            if (this.element.parentElement) {
                this.element.parentElement.removeChild(this.element);
            }
        }, 500);
    }

    renderProgress() {
        const progress = this.readState('bootProgress');
        const progressPercentage = (Math.floor(progress * 100)).toString();
        console.log(`[OnlineAppBooting] Progress ${progressPercentage}%`);
    }

    render() {
        this.conditionallySetHtmlClassState(this.readState('booting'), 'booting');
        this.renderProgress();
    }

}

export function getBooting(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppBooting(element, onlineApp);
}
